import foreign_worker_group_modal from "./ModalSchemas/foreign_worker_group_modal";
import foreign_worker_group_columns from "./TableColumns/foreign_worker_group_columns";
import foreign_worker_query from "./TableDataQueries/foreign_worker_query";
import foreign_worker_group_modal_columns from "./ModalTableColumns/foreign_worker_group_modal_columns";
import foreign_worker_search_query from "./TableDataQueries/foreign_worker_search_query";
import foreign_worker_modal from "./ModalSchemas/foreign_worker_modal";
import foreign_worker_columns from "./TableColumns/foreign_worker_columns";
import foreign_worker_group_query from "./TableDataQueries/foreign_worker_group_query";
import foreign_worker_modal_columns from "./ModalTableColumns/foreign_worker_modal_columns";

export const tableColumnsResolver = (
  type,
  formApi,
  linkedProfiles,
  setLinkedProfiles
) => {
  const lookup = {
    "foreign-worker-group": foreign_worker_group_columns(
      formApi,
      linkedProfiles,
      setLinkedProfiles
    ),
    "foreign-worker": foreign_worker_columns(
      formApi,
      linkedProfiles,
      setLinkedProfiles
    ),
  };
  return lookup[type] ?? [];
};

export const getDataQuery = (type, groupId, searchVal) => {
  const lookup = {
    "foreign-worker-group": foreign_worker_query(groupId),
    "foreign-worker": foreign_worker_group_query(groupId),
    "foreign-worker-search": foreign_worker_search_query(groupId, searchVal),
  };
  return lookup[type] ?? "";
};

export const profileLinkingModalSchemaResolver = (type) => {
  const lookup = {
    "foreign-worker-group": foreign_worker_group_modal,
    "foreign-worker": foreign_worker_modal,
  };
  return lookup[type] ?? {};
};

export const modalTableColumnsResolver = (
  type,
  linkedProfiles,
  setLinkedProfiles
) => {
  const lookup = {
    "foreign-worker-group": foreign_worker_group_modal_columns(
      linkedProfiles,
      setLinkedProfiles
    ),
    "foreign-worker": foreign_worker_modal_columns(
      linkedProfiles,
      setLinkedProfiles
    ),
  };
  return lookup[type] ?? [];
};

export const profilesMachineNameResolver = (type) => {
  const lookup = {
    "foreign-worker-group": "new_group_fw_profiles",
    "foreign-worker": "new_group_fw_groups",
  };
  return lookup[type];
};
